class PermittedAdmin {
  id?: string;

  email = '';

  hasAccount = false;

  isAuthor = false;
}

export default PermittedAdmin;
